export const CHANNEL = {
    WHOLESALE: 'wholesale',
    CORRESPONDENT: 'correspondent',
};

export function isWholesaleChannel(channel) {
    return channel?.toLowerCase().includes(CHANNEL.WHOLESALE);
}

export const isCorrespondent = (channel) => channel?.toLowerCase().includes(CHANNEL.CORRESPONDENT);

export function isCorrNDChannel(channel) {
    return channel?.toLowerCase().includes('corrnd');
}

export function isCommunityChannel(channel) {
    return channel?.toLowerCase().includes('community');
}

export function isAmbassadorINC({ loanType, incomeType, occupancy }) {
    return (
        loanType === 'Ambassador' &&
        occupancy === '1' && // Secondary Residence
        ["900", "9018", "9019"].includes(incomeType)
    );
}

export function isAcceleratorINC({ loanType, incomeType, incomeTypeText }) {
    return (
        loanType === 'Accelerator' &&
        incomeType !== '21' &&
        !incomeTypeText.includes('DSCR')
    );
}

export function isAccelerator58({ loanType, propertyType, units }) {
    return (
        loanType === 'Accelerator' &&
        (
            propertyType === '11' ||
            (propertyType === '8' && ["5", "6", "7", "8"].includes(units))
        )
    );
}
